<template>
  <div class="logouploader">
    <v-snackbar v-model="snackbar"
                top
                :color="snackbarColor"
                :timeout="timeout">
      {{snackbarText}}
      <v-btn text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <div class="logouploader__container">
      <h3 class="title">Logo</h3>
      <div class="upload-edit">
        <input multiple="multiple" type='file' id="imageUpload" @change="readUrl($event)" />
        <label for="imageUpload"></label>
      </div>
      <div class="upload-preview">
        <div id="logoPreview" :style="{backgroundImage: 'url('+logoSrc+')'}"></div>
      </div>
    </div>
    <div class="logouploader__error" v-show="showImageError !== ''">
      <span>{{ showImageError }}</span>
    </div>
    <div class="logouploader__upload" v-show="uploadImageButton">
      <button @click="imageFileUpload()" id="save_logo" class="btn upload_btn"><i class="material-icons">backup</i><span class="title">Upload Logo</span></button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { appActions } from '@/constants/'
import ApiService from '@/services/ApiService'
const { mapState } = createNamespacedHelpers('applicationState')

export default {
  name: 'thelogouploader',
  props: {
    logoSrc: String
  },
  data () {
    return {
      apiService: new ApiService(),
      fileImageIsValid: false,
      uploadImageButton: false,
      showImageError: '',
      imageFileJSON: {},
      snackbarText: 'Saved image successfully',
      snackbarColor: 'success',
      snackbar: false,
      timeout: 5000
    }
  },
  methods: {
    readUrl (input) {
      this.uploadImageButton = false
      this.showImageError = ''
      var filePath, fileExtension
      filePath = input.target.value
      var validFileExtensions = ['.png', '.gif', '.tiff', '.jpeg', '.jpg', '.bmp']

      if (filePath === '') {
        this.fileImageIsValid = false
      } else {
        fileExtension = validFileExtensions.filter(ext => ext === filePath.substring(filePath.lastIndexOf('.')).toLowerCase())[0]
        if (fileExtension === undefined || fileExtension === null) {
          this.showImageError = 'Please select an image file of type ' + validFileExtensions.join(', ')
          this.fileImageIsValid = false
        } else {
          var file = input.currentTarget.files.item(0)
          var reader = new FileReader()

          var that = this
          reader.onload = function () {
            that.imageFileResult(reader.result)
          }
          reader.readAsDataURL(file)
        }
      }
    },
    imageFileResult (data) {
      document.getElementById('logoPreview').style.backgroundImage = 'url(' + data + ')'
      this.uploadImageButton = true

      let file = data.split(',')
      let ext = file[0].replace('data:image/', '.').replace(';base64', '')
      let imageFile = {
        imageDescription: 'Logo for app ' + this.appName,
        imageData: file[1],
        fileExtension: ext
      }
      this.imageFileJSON = imageFile
    },
    imageFileUpload () {
      this.$store.dispatch('applicationState/' + appActions.SAVE_APP_SETTINGS_LOGO, { name: this.appName.replace(' ', ''), data: this.imageFileJSON })
        .then(data => {
          this.snackbarText = 'Saved successfully'
          this.snackbarColor = 'success'
          this.snackbar = true
          this.apiService.postAppList({ appId: this.appId, appName: this.appName, logoUrl: this.appLogoUrl })
        })
        .catch(err => {
          this.snackbarText = `Error: ${err}`
          this.snackbarColor = 'error'
          this.snackbar = true
        })

      this.uploadImageButton = false
    }
  },
  computed: {
    ...mapState({
      appLogoUrl: state => state.appLogoUrl,
      appName: state => state.appName,
      appId: state => state.appId
    })
  }
}
</script>

<style lang="scss">
  @import '@/scss/main.scss';

  .logouploader{
    &__container{
      position: relative;
      max-width: rem(160);
      margin: 0 auto rem(15) auto;

      @include breakpoint(tablet){
        margin: 0 auto rem(15) auto;
      }

      .title{
        margin: rem(10) auto;
      }

      .upload-edit{
        position: absolute;
        right: rem(2);
        z-index: 1;
        bottom: rem(-15);

        input {
          display: none;

          + label{
            display: inline-block;
            width: rem(80);
            height: rem(25);
            margin-bottom: 0;
            border-radius: rem(5);
            background: rgba($light, 0.5);
            border: 1px solid $primary;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
            cursor: pointer;
            font-weight: normal;
            transition: all .2s ease-in-out;
            &:hover {
              background: #f1f1f1;
              border-color: #d6d6d6;
            }

            &:after {
              content: "Change Logo";
              font-family: $font-stack;
              font-size: rem(12);
              color: $primary;
              position: absolute;
              top: rem(6);
              left: 0;
              right: 0;
              text-align: center;
              margin: auto;
            }
          }
        }
      }

      .upload-preview{
        width: rem(125);
        height: rem(125);
        position: relative;
        border-radius: 100%;
        border: 6px solid rgba($dark-light, 0.5);
        box-shadow: 0px 2px 4px 0px rgba($dark-light, 0.8);
        overflow: hidden;

        #logoPreview {
          width: 120%;
          height: 120%;
          position: absolute;
          top: rem(-10);
          left: rem(-10);
          border-radius: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
    &__error{
      color: $danger;
      margin: 0 auto rem(10) auto;

      span {
        max-width: rem(140);
        display: inline-block;
        line-height: rem(14);
        font-size: rem(14);
      }
    }
     &__upload{
      .upload_btn{
        color: $light;
        background-color: rgba($primary, 0.8);
        padding: rem(8) rem(14) rem(8) rem(16);

        .title{
            margin-left: rem(-8);
          font-size: rem(14);
        }
        .material-icons{
          color: rgba($light, 1);
          left: rem(-14);

          &:before{
            top: rem(-14);
            left: rem(-6);
            width: rem(38);
            height: rem(37);
            border-radius: rem(10) 0 0 rem(10);
            border-top-width: 1px;
            border-top-color: $primary;
            border-top-style: solid;
            border-bottom-width: 1px;
            border-bottom-color: $primary;
            border-bottom-style: solid;
            border-left-width: 1px;
            border-left-color: $primary;
            border-left-style: solid;
          }
        }

        &:hover{
          background-color: rgba($primary, 1);
          padding: rem(8) rem(14) rem(8) rem(8);
          transition: 0.4s;

          .title{
            margin-left: rem(-2);
            font-size: rem(14);
            transition: 0.4s;
          }

          .material-icons{
            color: rgba($primary, 1);
            left: rem(-18);

            &:before{
              top: rem(-14);
              left: rem(-6);
              width: rem(38);
              height: rem(37);
              border-radius: rem(10) 0 0 rem(10);
              border-top-width: 1px;
              border-top-color: $primary;
              border-top-style: solid;
              border-bottom-width: 1px;
              border-bottom-color: $primary;
              border-bottom-style: solid;
              border-left-width: 1px;
              border-left-color: $primary;
              border-left-style: solid;
              opacity: 1;
              transition: 0.5s;
              transition-delay: 0.1s;
              transition-property: all;
            }
            &:after{
              opacity: 1;
              left: rem(26);
              transition: 0.2s;
              transition-delay: 0.4s;
              transition-property: all;
            }
          }
        }

        &:active {
          transform: translateY(4px);
          transition: 0.2s;
        }
      }
    }
  }

</style>
